module.exports = __webpack_public_path__ + "img/品牌活动@2x.29907649.png";